<template>
  <app-loading-section :loading="loading">
    <div class="notification_box--wrapper">
      <div class="notification_box" @click="goToNewLeadsInbox">
        <p class="notification_box--count">{{ newLeadsCount }}</p>
        <p class="notification_box--label">New Leads</p>
      </div>
      <div class="notification_box" @click="goToResponsesInbox">
        <p class="notification_box--count">{{ responsesCount }}</p>
        <p class="notification_box--label">Responses</p>
      </div>
      <div class="notification_box" @click="openMentionNotificationsModal">
        <p class="notification_box--count">{{ mentionsCount }}</p>
        <p class="notification_box--label">Mentions</p>
      </div>
    </div>

    <div class="flex flex-end flex-vertical-center">
      <p
        v-if="errorsCount"
        class="error_notification mr-auto"
        @click="openErrorNotificationsModal"
      >{{ errorsCount }} Error Notifications</p>

      <p class="video_link">
        <app-help-link
          youtube-link="https://youtu.be/YedF8bI_gWs"
          is-video
        >Learn More</app-help-link>
      </p>
    </div>
  </app-loading-section>
</template>

<script>
import {ENUMS} from "../../../services/enums";

export default {
  name: "UserDashboardNotificationsBox",
  data() {
    return {
      loading: true
    }
  },
  mounted() {
    this.loading = false
  },
  computed: {
    newLeadsCount() {
      return this.$store.getters["dashboard/newRecordsCount"]
    },
    responsesCount() {
      return this.$store.getters["dashboard/responsesCount"]
    },
    mentionsCount() {
      return this.$store.getters.mentionsCount;
    },
    errorsCount() {
      return this.$store.getters.errorsCount;
    }
  },
  methods: {
    goToNewLeadsInbox() {
      this.$router.push({name: "inbox", params: {'tab': 'leads'}, query: {'user': this.$store.getters.authUser.id}});
    },
    goToResponsesInbox() {
      this.$router.push({name: "inbox", params: {'tab': 'responses'}, query: {'user': this.$store.getters.authUser.id}});
    },
    openMentionNotificationsModal() {
      this.$router.replace({query: {modal: 'notifications', tab: ENUMS.NotificationCategoryEnum.Mentions.key}});
    },
    openErrorNotificationsModal() {
      this.$router.replace({query: {modal: 'notifications', tab: ENUMS.NotificationCategoryEnum.Errors.key}});
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

// NOTE: All font sizes must be px because the height is fixed and rem could break the layout
.notification_box--wrapper {
  display: flex;
  justify-content: stretch;
  padding: 14px 14px 0;
}

.notification_box {
  flex-grow: 1;
  margin-bottom: 12px;
  padding: 10px;
  background-color: $primary;
  color: $white;
  text-align: center;
  font-weight: bold;
  cursor: pointer;

  &--count {
    margin-bottom: 6px;
    font-size: 32px;
  }

  &--label {
    font-size: 12px;
  }

  &:hover {
    background-color: $secondary;
  }

  &:not(:last-child) {
    margin-right: 10px;
  }
}

.error_notification {
  padding: 0 14px;
  font-size: 0.75rem;
  color: $danger;
  cursor: pointer;

  &:hover {
    color: $primary;
  }
}

.video_link {
  padding: 0 14px;
  text-align: right;
}
</style>
